import { grey } from "@faro-lotv/flat-ui";

/** This is the color used by the automatic face blurring backend. */
export const MANUAL_BLUR_COLOR = grey[700];
